export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repeat operation"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["History of transactions"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["List of accounts"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unknown error"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["List of tokens"])}
}